/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';
import { LoadingIndicator } from 'app/components/LoadingIndicator';

export const CourseUsers = lazyLoad(
  () => import('./index'),
  course => course.CourseUsers,
  {
    fallback: <LoadingIndicator />,
  },
);
